const CATEGORY_ORDER = [
    'promociones',
    'listo para consumir',
    'granja',
    'bebida',
    'mascota',
    'planta'
];

const normalizeCategory = (value: string) => value.trim().toLocaleLowerCase('es');

export const getCategoryOrder = (name?: string | null) => {
    const normalized = normalizeCategory(name || '');
    const index = CATEGORY_ORDER.findIndex(category =>
        normalized === category || normalized.startsWith(`${category}s`)
    );
    return index === -1 ? CATEGORY_ORDER.length : index;
};

export const sortByCategoryOrder = <T extends { nombre: string }>(items: T[]) =>
    [...items].sort((a, b) =>
        getCategoryOrder(a.nombre) - getCategoryOrder(b.nombre) ||
        a.nombre.localeCompare(b.nombre, 'es')
    );
